import { Col, FormGroup, Label, Row } from "reactstrap";
import CommonFileUpload from "../../../Common/CommonFileUpload";
import { UploadProjectFiles } from "../../../Constant";

const UploadProjectFile = () => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{UploadProjectFiles}</Label>
          <CommonFileUpload />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default UploadProjectFile;
